import AcademicEducation from "./AcademicEducation";
import { InformationResource } from "./InformationResource";
import { Language } from "./Language";

interface IProps {  
  formik: any;
  showErrorsInputs:boolean;
  setShowErrorsInputs:(data:boolean) => void;
}
export const SecondStepForm = (props: IProps) => {
  const { formik } = props;
  return (
    <div className="step-form animate__animated animate__fadeIn">
      <AcademicEducation formik={formik} showErrorsInputs={props.showErrorsInputs} setShowErrorsInputs={props.setShowErrorsInputs} />
      <Language formik={formik} showErrorsInputs={props.showErrorsInputs} setShowErrorsInputs={props.setShowErrorsInputs} />
      <InformationResource formik={formik} showErrorsInputs={props.showErrorsInputs} />
    </div>
  );
};
